import { render, staticRenderFns } from "./CustomerEdit.vue?vue&type=template&id=58f6984f&scoped=true"
import script from "./CustomerEdit.vue?vue&type=script&lang=js"
export * from "./CustomerEdit.vue?vue&type=script&lang=js"
import style0 from "./CustomerEdit.vue?vue&type=style&index=0&id=58f6984f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f6984f",
  null
  
)

export default component.exports